export class UpdateHideModal {
  static readonly type = '[Feedback] Update Hide Modal';
  constructor(public hideModal: boolean) {}
}
